import { customSeriesDefaultOptions, type CustomSeriesOptions } from 'lightweight-charts';

export interface StackedAreaColor {
    line: string;
    area: string;
  }
  
  export interface StackedAreaSeriesOptions extends CustomSeriesOptions {
    colors?: readonly StackedAreaColor[];
    lineWidth: number;
  }

  export const defaultOptions: StackedAreaSeriesOptions = {
    ...customSeriesDefaultOptions,
    lineWidth: 2,
    lastValueVisible: false,
    priceLineVisible: false,
  } as const;